export const SET_PAGES = 'SET_PAGES';
export const SET_PAGE = 'SET_PAGE';
export const ADD_PAGE = 'ADD_PAGE';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const REMOVE_PAGE = 'REMOVE_PAGE';
export const CLEAR_PAGE = 'CLEAR_PAGE';
export const CLEAR_PAGES = 'CLEAR_PAGES';
